

export const CREATE_ORDER_PLANNING_TITLE = 'Create Order Planning';
export const BACK_TO_MENU = 'Back to Menu';
export const ORDER_PLANNING_TITLE = 'Order Planning';
export const DEFAULT_SORT_BY_HEAD_CELL = 'name';

export const ROWS_PER_PAGE_LABEL = 'Order planning per page'

export const DEFAULT_ROWS_PER_PAGE = 50;

export const ORDER_PLANNING_TABLE_HEAD_CELLS = [
    { id: 'planName', numeric: false, disablePadding: false, label: 'Plan Name' }
];

export const generateId = () => '_' + Math.random().toString(36).substr(2, 9);

export const dynamicColumnTypes = ['Product Requirements', 'Open Purchase Orders', 'New Purchase Orders', 'FTL In Transit'];